import { showToastWithAction } from '@app/components/ToastWithAction';
import { Store } from '@app/types/store';
import MixpanelService from '@app/utils/mixpanel.service';
import { pushState } from '@app/utils/routing';
import { camelToSnakeCase } from '@app/utils/snakeCamelTransform';
import { toast } from 'react-toastify';

export const isStoreConnected = ({ authState, requiresReauthorizePermission }: Store) =>
  authState !== 'auth_failed' && !requiresReauthorizePermission;

export const handleStoreConnectionError = (store: Store, message: string, actionText: string) => {
  if (!toast.isActive(`store-connection-error-${store.id}`))
    showToastWithAction(message, {
      toastId: `store-connection-error-${store.id}`,
      actionLabel: actionText,
      onActionLabelClick: () => {
        MixpanelService.track('Disconnected Store - See Details - Toast', {
          source: 'Create Shipments > Advanced',
          store_id: store.id,
          store_name: store.name,
          platform: store.platform.cssClass,
        });
        pushState(`/store/${store.id}`);
      },
    });
};

export const alertDisconnectedStores = (stores: Store[]) => {
  const event = new CustomEvent('disconnectedStores:alert', { detail: camelToSnakeCase(stores) });
  document.dispatchEvent(event);
};
